import { ICategoryItem } from './material.interface';

export const MaterialCategory: ICategoryItem[] = [{
  value: '1',
  label: '图文素材'
}];
